import React from "react";
import Card from "react-bootstrap/Card";
import {
  selectLocationByCode,
  useGetQuestionnaireQuery,
} from "../features/rapidstor/rapidstorApiSlice";
import { useSelector } from "react-redux";
import { RootState } from "../store";
import classes from "./LocationCard.module.scss";
import Image from "react-bootstrap/Image";
import imageL002 from "../assets/facility-L002.png";
import imageL003 from "../assets/facility-L003.png";
import imageL004 from "../assets/facility-L004.png";
import imageL007 from "../assets/facility-L007.png";
import imageL008 from "../assets/facility-L008.jpg";
import imageL005 from "../assets/facility-L005.jpg";
import imageL009 from "../assets/facility-L009.jpeg";
import imageL010 from "../assets/facility-L010.jpeg";
import imageL011 from "../assets/facility-L011.png";
import imageL012 from "../assets/facility-L012.jpg";
import imageL013 from "../assets/facility-L013.jpg";
import imageL014 from "../assets/facility-L014.jpg";
import imageL015 from "../assets/facility-L015.jpg";
import imageDefault from "../assets/facility-default.png";
import { ReactComponent as IconRightChevron } from "../assets/icon-right-chevron.svg";
import MediumHeader from "./MediumHeader";
import SmallDetail from "./SmallDetail";

interface Props {
  locationCode: string;
}

function LocationCard({ locationCode }: Props) {
  const location = useSelector((state: RootState) =>
    selectLocationByCode(state, locationCode)
  );
  // Prefetch the questionnaire for this location
  useGetQuestionnaireQuery(location?.locationCode ?? "", { skip: !location });

  // This might happen if LocationCard is called with a location code that
  // hasn't been loaded yet.
  // @TODO: replace with ghost element
  if (!location) {
    return <></>;
  }

  const image =
    {
      L002: imageL002,
      L003: imageL003,
      L004: imageL004,
      L007: imageL007,
      L008: imageL008,
      L005: imageL005,
      L009: imageL009,
      L010: imageL010,
      L011: imageL011,
      L012: imageL012,
      L013: imageL013,
      L014: imageL014,
      L015: imageL015,
    }[locationCode] ?? imageDefault;

  const addressLine = [location.address.address1, location.address.address2]
    .filter(Boolean)
    .join(" ");

  return (
    <Card className={`${classes.card} ${classes.expanded} ${classes.location}`}>
      <Card.Body className={classes.cardBody}>
        <Image src={image} className={classes.photo} />
        <div className={classes.facilityInfo}>
          <MediumHeader className={classes.name}>Storage {location?.name}</MediumHeader>
          <SmallDetail className={classes.address}>
            {addressLine}, {location.address.city} {location.address.region}
          </SmallDetail>
        </div>
        <IconRightChevron className={`flex-shrink-0 ${classes.arrow}`} />
      </Card.Body>
    </Card>
  );
}

export default LocationCard;
